"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const MultiplicityUtilities_1 = require("../../panels/extra/utilities/MultiplicityUtilities");
const TreeColors_1 = require("./TreeColors");
function createTreeNodes(signal, spectrumData) {
    function buildTreeNodesData(multiplicityIndex, jIndices, treeNodesData, startX) {
        if (!signal.multiplicity) {
            return null;
        }
        if (multiplicityIndex >= signal.multiplicity.length) {
            return treeNodesData;
        }
        // re-use colors if needed
        const color = TreeColors_1.TREE_LEVEL_COLORS[multiplicityIndex % TreeColors_1.TREE_LEVEL_COLORS.length];
        const jIndex = jIndices.indexOf(multiplicityIndex);
        const frequency = (0, get_1.default)(spectrumData, 'info.originFrequency', 0);
        const coupling = jIndex >= 0 && frequency > 0 && signal?.js?.[jIndex]
            ? signal.js[jIndex].coupling / frequency // convert to ppm
            : null;
        // in case of "s": no coupling constant and build one tree node only
        if (!coupling) {
            treeNodesData.push({
                startX,
                _startX: startX,
                ratio: 1,
                multiplicityIndex,
                color,
            });
            // go to next multiplet in multiplicity string
            buildTreeNodesData(multiplicityIndex + 1, jIndices, treeNodesData, startX);
        }
        else {
            // in case of other multiplets
            const multiplicity = signal.multiplicity || '';
            const pascal = (0, MultiplicityUtilities_1.getPascal)((0, MultiplicityUtilities_1.getMultiplicityNumber)(multiplicity.charAt(multiplicityIndex)), 0.5); // @TODO for now we use the default spin of 1 / 2 only
            let _startX = pascal.length % 2 === 0
                ? startX - (pascal.length / 2) * coupling + coupling / 2 // in case of even number of nodes
                : startX - (pascal.length / 2 - 0.5) * coupling; // in case of odd number of nodes
            for (const [k, ratio] of pascal.entries()) {
                if (k > 0) {
                    _startX += coupling;
                }
                treeNodesData.push({
                    startX,
                    _startX,
                    ratio,
                    multiplicityIndex,
                    color,
                });
                // go to next multiplet in multiplicity string
                buildTreeNodesData(multiplicityIndex + 1, jIndices, treeNodesData, _startX);
            }
        }
        return treeNodesData;
    }
    return buildTreeNodesData;
}
exports.default = createTreeNodes;
